import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractCommand from './abstractCommand';

/**
 * Rotate item command
 *
 * @class RotateItemCommand
 * @extends AbstractCommand
 */
export default class RotateItemCommand extends AbstractCommand {
    constructor(item, rotation, center) {
        super();
        this.item = item;
        this.initialRotation = this.item.get('rotation');
        this.rotation = rotation !== undefined ? rotation : this.initialRotation;
        this.center = center;
    }

    /**
     * Is this a valid command?
     *
     * @return {boolean}
     */
    isValid() {
        return this.item.supportsRotation;
    }

    /**
     * Set rotation
     *
     * @param {number} rotation
     */
    setRotation(rotation) {
        this.rotation = rotation;
    }

    /**
     * Set rotation center
     *
     * @param {Point} center
     */
    setCenter(center) {
        this.center = center;
    }

    /**
     * Execute command
     */
    execute() {
        const options = {};

        if (!this.isValid()) {
            return;
        }

        if (this.center) {
            options.center = this.center;
        }

        this.item.set('rotation', this.rotation, options);
    }

    /**
     * Unexecute command
     */
    unexecute() {
        if (!this.isValid()) {
            return;
        }

        this.item.set('rotation', this.initialRotation, this.options);
    }

    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        return `Rotate ${this.item.attributes.type}`;
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.RotateItemCommand = RotateItemCommand;
